import React, { Component, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Academics from "./pages/Academics";
import Admissions from "./pages/Admissions";
import NewsEvents from "./pages/NewsEvents";
import ContactUs from "./pages/ContactUs";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Vacancies from "./pages/vacancies";
import PdfUpload from "./pages/PdfUpload";

import StudentDetails from "./pages/StudentDetails"; // ...
import Login from "./pages/Login";
import TeacherLogin from "./pages/TeacherLogin";
import TeacherDashboard from "./pages/TeacherDashboard";
import AddEventForm from "./pages/AddEventForm";
import StudentOnboarding from "./pages/StudentOnboarding";
import StudentOnboardingQueue from "./pages/StudentOnboardingQueue";
import StudentDetailsForm from "./components/StudentDetailsForm";
import StudentExcelManager from "./pages/StudentExcelManager";

import ManagerComponent from "./pages/ManagerComponent";
import ClassPromotionManager from "./pages/ClassPromotionManager";
import ViewPayments from "./pages/ViewPayments";
import AuthCard from "./pages/AuthCard";
import Noticeboard from "./pages/Noticeboard";
import PaymentCard from "./pages/PaymentCard";
import AdminEventManager from "./pages/AdminEventManager";
import EventDetail from "./pages/EventDetail";
import Profile from "./pages/Profile";
import ClassUpdaterButtons from "./pages/ClassUpdaterButtons";
import ManageCircular from "./pages/ManageCircular";
import Dashboard from "./pages/Dashboard";
import ManageHomeCarousel from "./pages/ManageHomeCarousel";
import ManageGalleryImages from "./pages/ManageGalleryImages";
import ManageGalleryInauguration from "./pages/ManageGalleryInauguration";
import ManageGallerySchoolLife from "./pages/ManageGallerySchoolLife";
import ManageUpdatesPopup from "./pages/ManageUpdatesPopup";
import ManageNotices from "./pages/ManageNotices";
import ManageVacancies from "./pages/ManageVacancies";
import StaffAttendanceManagement from "./pages/StaffAttendanceManagement";
import StudentQrManager from "./pages/StudentQrManager";
import AdmissionsQrBulkUpload from "./pages/AdmissionsQrBulkUpload";
import RoleProtectedRoute from "./components/RoleProtectedRoute";
import { PERMISSIONS } from "./utils/roleAccess";
import { applySeo, DEFAULT_DESCRIPTION, DEFAULT_TITLE } from "./utils/seo";
import toast, { Toaster } from "react-hot-toast";
import MandatoryPublicDisclosure from "./components/MandatoryPublicDisclosure";

const SEO_BY_PATH = {
  "/": {
    title: `${DEFAULT_TITLE} | Home`,
    description:
      "Welcome to Rising Stars Public School. Explore academics, admissions, news, and campus life.",
  },
  "/about": {
    title: `${DEFAULT_TITLE} | About Us`,
    description:
      "Learn about Rising Stars Public School, our mission, vision, values, and leadership.",
  },
  "/academics": {
    title: `${DEFAULT_TITLE} | Academics`,
    description:
      "Discover our academic programs, curriculum highlights, and co-curricular activities.",
  },
  "/admissions": {
    title: `${DEFAULT_TITLE} | Admissions`,
    description:
      "Admissions information, eligibility, required documents, and application guidance.",
  },
  "/news-and-events": {
    title: `${DEFAULT_TITLE} | News & Events`,
    description:
      "Latest news, events, and celebrations from Rising Stars Public School.",
  },
  "/contact": {
    title: `${DEFAULT_TITLE} | Contact Us`,
    description:
      "Get in touch with Rising Stars Public School for admissions and general enquiries.",
  },
  "/privacy": {
    title: `${DEFAULT_TITLE} | Privacy Policy`,
    description: "Read our privacy policy and data handling practices.",
  },
  "/terms": {
    title: `${DEFAULT_TITLE} | Terms of Service`,
    description: "Review the terms and conditions for using our services.",
  },
  "/vacancies": {
    title: `${DEFAULT_TITLE} | Vacancies`,
    description: "View current openings and career opportunities.",
  },
  "/pdfupload": {
    title: `${DEFAULT_TITLE} | Uploads`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/login": {
    title: `${DEFAULT_TITLE} | Login`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/teacher-login": {
    title: `${DEFAULT_TITLE} | Teacher Login`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/teacher-dashboard": {
    title: `${DEFAULT_TITLE} | Teacher Dashboard`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/admin-dashboard": {
    title: `${DEFAULT_TITLE} | Admin Dashboard`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/manage-events": {
    title: `${DEFAULT_TITLE} | Manage Events`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/add-event": {
    title: `${DEFAULT_TITLE} | Add Event`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/manage-dashboard": {
    title: `${DEFAULT_TITLE} | Manage Dashboard`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/manage-home-carousel": {
    title: `${DEFAULT_TITLE} | Manage Home Carousel`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/manage-vacancies": {
    title: `${DEFAULT_TITLE} | Manage Vacancies`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/manage-circulars": {
    title: `${DEFAULT_TITLE} | Manage Circulars`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/view-payments": {
    title: `${DEFAULT_TITLE} | View Payments`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/add-user": {
    title: `${DEFAULT_TITLE} | Add User`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/notice-board": {
    title: `${DEFAULT_TITLE} | Notice Board`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/update-student": {
    title: `${DEFAULT_TITLE} | Update Student`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/student-onboarding": {
    title: `${DEFAULT_TITLE} | Student Onboarding`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/student-onbarding": {
    title: `${DEFAULT_TITLE} | Student Onboarding Queue`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/update-payment": {
    title: `${DEFAULT_TITLE} | Update Payment`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/payment": {
    title: `${DEFAULT_TITLE} | Payment`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/normalizeClass": {
    title: `${DEFAULT_TITLE} | Normalize Class`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/staff-attendance": {
    title: `${DEFAULT_TITLE} | Staff Attendance`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/profile": {
    title: `${DEFAULT_TITLE} | Profile`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/student-qr-manager": {
    title: `${DEFAULT_TITLE} | Student QR Manager`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
  "/admissions-qr-bulk": {
    title: `${DEFAULT_TITLE} | Admissions QR Bulk Upload`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, nofollow",
  },
};

function resolveSeoForPath(pathname) {
  if (SEO_BY_PATH[pathname]) return SEO_BY_PATH[pathname];
  if (pathname.startsWith("/events/")) {
    return {
      title: `${DEFAULT_TITLE} | Event Details`,
      description: "View event details, highlights, and media.",
      type: "article",
    };
  }
  if (pathname.startsWith("/student-onboarding/")) {
    return {
      title: `${DEFAULT_TITLE} | Student Onboarding`,
      description: DEFAULT_DESCRIPTION,
      robots: "noindex, nofollow",
    };
  }
  if (pathname.startsWith("/student/")) {
    return {
      title: `${DEFAULT_TITLE} | Student Details`,
      description: DEFAULT_DESCRIPTION,
      robots: "noindex, nofollow",
    };
  }
  return {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  };
}

function AppLayout() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const sourceRaw =
    searchParams.get("source") ||
    searchParams.get("sourceId") ||
    searchParams.get("source_id") ||
    "";
  const source = String(sourceRaw)
    .toLowerCase()
    .replace(/[\s_-]/g, "");
  const isMobileSource =
    source === "mobile" ||
    source === "mobilenative" ||
    source === "mobilenativ" ||
    source.startsWith("mobilenativ");

  useEffect(() => {
    const seo = resolveSeoForPath(location.pathname);
    const url = `${window.location.origin}${location.pathname}`;
    applySeo({ ...seo, url });
  }, [location.pathname]);

  return (
    <div>
      {!isMobileSource && <Navbar />}
      <div className={isMobileSource ? "" : "pt-20"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/academics" element={<Academics />} />
          <Route path="/admissions" element={<Admissions />} />
          <Route path="/news-and-events" element={<NewsEvents />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/vacancies" element={<Vacancies />} />
          <Route path="/pdfupload" element={<PdfUpload />} />
          <Route
            path="/add-event"
            element={
              <RoleProtectedRoute permission={PERMISSIONS.CREATE_EVENTS}>
                <AddEventForm />
              </RoleProtectedRoute>
            }
          />
          <Route path="/student/:studentId" element={<StudentDetails />} />
          <Route path="/login" element={<Login />} />
          <Route path="/update-student" element={<StudentDetailsForm />} />
          <Route
            path="/student-excel-manager"
            element={<StudentExcelManager />}
          />
          <Route
            path="/generate-students-db"
            element={<StudentExcelManager />}
          />
          <Route
            path="/class-promotion-manager"
            element={<ClassPromotionManager />}
          />
          <Route path="/student-qr-manager" element={<StudentQrManager />} />
          <Route path="/student-onboarding" element={<StudentOnboarding />} />
          <Route
            path="/student-onboarding/:uid"
            element={<StudentOnboarding />}
          />
          <Route
            path="/student-onbarding"
            element={<StudentOnboardingQueue />}
          />
          <Route path="/teacher-login" element={<TeacherLogin />} />
          <Route path="/admin-dashboard" element={<ManagerComponent />} />
          <Route
            path="/manage-circulars"
            element={
              <RoleProtectedRoute permission={PERMISSIONS.MANAGE_CIRCULARS}>
                <ManageCircular />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/view-payments"
            element={
              <RoleProtectedRoute permission={PERMISSIONS.VIEW_PAYMENTS}>
                <ViewPayments />
              </RoleProtectedRoute>
            }
          />
          <Route path="/add-user" element={<AuthCard />} />
          <Route path="/notice-board" element={<Noticeboard />} />
          <Route path="/manage-dashboard" element={<Dashboard />} />
          <Route
            path="/staff-attendance"
            element={<StaffAttendanceManagement />}
          />
          <Route
            path="/manage-home-carousel"
            element={<ManageHomeCarousel />}
          />
          <Route
            path="/manage-gallery-images"
            element={<ManageGalleryImages />}
          />
          <Route
            path="/manage-gallery-images/inauguration"
            element={<ManageGalleryInauguration />}
          />
          <Route
            path="/manage-gallery-images/school-life"
            element={<ManageGallerySchoolLife />}
          />
          <Route
            path="/manage-updates-popup"
            element={<ManageUpdatesPopup />}
          />
          <Route
            path="/manage-notices"
            element={
              <RoleProtectedRoute permission={PERMISSIONS.MANAGE_NOTICES}>
                <ManageNotices />
              </RoleProtectedRoute>
            }
          />
          <Route path="/manage-vacancies" element={<ManageVacancies />} />

          <Route path="/teacher-dashboard" element={<TeacherDashboard />} />
          <Route path="/normalizeClass" element={<ClassUpdaterButtons />} />
          <Route path="/update-payment" element={<PaymentCard />} />
          <Route path="/payment" element={<PaymentCard />} />
          <Route
            path="/manage-events"
            element={
              <RoleProtectedRoute permission={PERMISSIONS.MANAGE_EVENTS}>
                <AdminEventManager />
              </RoleProtectedRoute>
            }
          />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/profile" element={<Profile />} />
          <Route
            path="/admissions-qr-bulk"
            element={<AdmissionsQrBulkUpload />}
          />
          <Route
            path="/mandatory-public-disclosure"
            element={<MandatoryPublicDisclosure />}
          />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

class GlobalErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    const message =
      error?.message || "Something went wrong. Please refresh and try again.";
    toast.error(message, { id: "global-react-boundary-error" });
    console.error("React error boundary caught:", error);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
          <div className="max-w-lg w-full rounded-2xl border border-slate-200 bg-white p-8 shadow-sm text-center">
            <h1 className="text-2xl font-bold text-slate-800 mb-3">
              Something went wrong
            </h1>
            <p className="text-slate-600 mb-6">
              An unexpected error occurred. Please refresh the page.
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              className="rounded-lg bg-blue-600 px-5 py-2.5 text-white font-semibold hover:bg-blue-700 transition"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const formatErrorMessage = (errorLike) => {
      if (!errorLike) return "Unexpected error occurred";
      if (typeof errorLike === "string") return errorLike;
      return errorLike?.message || "Unexpected error occurred";
    };

    const onWindowError = (event) => {
      const message = formatErrorMessage(event?.error || event?.message);
      toast.error(message, { id: `runtime-error:${message}` });
      console.error("Uncaught runtime error:", event?.error || event);
    };

    const onUnhandledRejection = (event) => {
      const message = formatErrorMessage(event?.reason);
      toast.error(message, { id: `promise-rejection:${message}` });
      console.error("Unhandled promise rejection:", event?.reason);
    };

    window.addEventListener("error", onWindowError);
    window.addEventListener("unhandledrejection", onUnhandledRejection);

    return () => {
      window.removeEventListener("error", onWindowError);
      window.removeEventListener("unhandledrejection", onUnhandledRejection);
    };
  }, []);

  return (
    <Router>
      <Toaster position="top-right" reverseOrder={false} />
      <GlobalErrorBoundary>
        <AppLayout />
      </GlobalErrorBoundary>
    </Router>
  );
}

export default App;
